import React from "react";
import classNames from "classnames";

interface FlexProps {
    inline?: boolean;
    reverse?: boolean;
    vertical?: boolean;

    content?: "start" | "end" | "center" | "between" | "around";
    align?: "center" | "start" | "end" | "baseline" | "stretch";
    grow?: boolean;
    gap?: any;
    wrap?: false | true | "no" | "reverse";

    className?: string;
    children?: any;
    [x: string]: any;
}

export const Flex = ({ inline, reverse, vertical, content, align, wrap, grow, gap, className, children, ...props }: FlexProps) => {
    var dir = reverse ? (vertical ? "flex-column-reverse" : "flex-row-reverse") : vertical ? "flex-column" : null;

    var cn = classNames(className, dir, {
        "d-flex": !inline,
        "d-inline-flex": inline,
        "flex-grow-1": grow,
        "flex-wrap": wrap === true,
        "flex-nowrap": wrap === "no",
        "flex-wrap-reverse": wrap === "reverse",

        "justify-content-start": content === "start",
        "justify-content-end": content === "end",
        "justify-content-center": content === "center",
        "justify-content-between": content === "between",
        "justify-content-around": content === "around",

        "align-items-start": align === "start",
        "align-items-end": align === "end",
        "align-items-center": align === "center",
        "align-items-baseline": align === "baseline",
        "align-items-stretch": align === "stretch",

        ["gap-" + gap]: !!gap,
    });

    return (
        <div className={cn} {...props}>
            {children}
        </div>
    );
};
